"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const ADVANTAGE_IMAGE_SRC = "/image/new-version/fabrication/laser-cutting/advantages.webp";

const ADVANTAGE_KEYS = [
	{ titleKey: "item1Title", descKey: "item1Desc" },
	{ titleKey: "item2Title", descKey: "item2Desc" },
	{ titleKey: "item3Title", descKey: "item3Desc" },
	{ titleKey: "item4Title", descKey: "item4Desc" },
] as const;

const CheckCircleIcon = () => (
	<svg className="mt-1 h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="none" aria-hidden="true">
		<circle cx="10" cy="10" r="8" fill="#78b63f" />
		<path
			d="M6.4 10.2L8.7 12.4L13.6 7.6"
			stroke="white"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default function LaserCuttingAdvantages() {
	const t = useTranslations("laserCuttingAdvantagesSection");

	return (
		<section className="py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="mb-6 sm:mb-8 md:mb-10 lg:mb-12">
					<p className="mb-3 text-sm font-medium uppercase tracking-wide text-[#78b63f]">{t("eyebrow")}</p>
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("title")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("intro")}</p>
				</div>

				<div className="grid grid-cols-1 items-start gap-8 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-10 xl:gap-14">
					<div className="relative aspect-[23/17] w-full overflow-hidden bg-gray-100">
						<Image
							src={encodeURI(ADVANTAGE_IMAGE_SRC)}
							alt={t("imageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 52vw"
						/>
					</div>

					<div className="space-y-7">
						{ADVANTAGE_KEYS.map((item) => (
							<div key={item.titleKey}>
								<p className="mb-2 flex items-start gap-3">
									<CheckCircleIcon />
									<span className="text-base font-semibold leading-tight text-black sm:text-lg">
										{t(item.titleKey)}
									</span>
								</p>
								<p className="pl-8 text-sm leading-relaxed text-black md:text-base">{t(item.descKey)}</p>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
